<template>
  <div>
    <div class="col-lg-2">
      <base-button
        style="font-size: 18px"
        @click="getBack()"
        class="btn-link btn-primary"
      >
        &lt; Back
      </base-button>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <simple-wizard ref="tabs" :indextghrunning="huhuhaha" :totalstep="hoi">
          <template slot="header">
            <h2 class="card-title"></h2>
            <h3 class="description"></h3>
          </template>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step1')"
          >
            <template slot="label">
              1
              <p style="color: #A5A5A5; width: 200px">Job Information</p>
            </template>
            <first-step
              v-if="firstflag"
              @my-event="myFunction"
              ref="step1"
              @on-validated="onStepValidated"
            ></first-step>
          </wizard-tab>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step2')"
          >
            <template slot="label">
              2
              <p style="color: #A5A5A5; width: 200px">Transporter Information</p>
            </template>
            <second-step
              v-if="secondflag"
              @my-event="myFunction"
              ref="step2"
              @on-validated="onStepValidated"
            ></second-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step3')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              3
              <p style="color: #A5A5A5; width: 200px">Additional Documents</p>
            </template>
            <third-step
              v-if="thirdflag"
              @my-event="myFunction"
              ref="step3"
              @on-validated="onStepValidated"
            ></third-step>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "../Vendor/JobPage/JobInformation.vue";
import SecondStep from "../Vendor/JobPage/TransportInformation.vue";
import ThirdStep from "../Vendor/JobPage/AdditionalDocuments.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab,
  },
  data() {
    return {
      firstflag: true,
      secondflag: false,
      thirdflag: false,
      wizardModel: {},
      activeTabIndex: 0,
      jobstatus: "",
      landvesselflag: "VESSEL",
      huhuhaha: 0,
      hoi: 0,
      componentKey: 0,
    };
  },
  created() {
    this.huhuhaha = 1;
  },
  methods: {
    myFunction(e) {
      this.secondflag = false;
      this.thirdflag = false;
      this.flag = false;
      let index = parseInt(e.step);

      this.hoi = 3;

      if (e.direction == "depan") {
        if (e.step == "0") {
           
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.huhuhaha = 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }
        if (e.step == "1") {
          this.secondflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.huhuhaha = 2;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }
        if (e.step == "2") {
          this.thirdflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = true;
            this.$refs.tabs.tabs[this.hoi - 1].checked = true;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.huhuhaha = 3;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }
      }

      if (e.direction == "blkg") {
        if (e.step == "1") {
          this.getBack();
        }
        if (e.step == "2") {
          this.firstflag = true;
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
          this.$refs.tabs.tabs[this.hoi - 1].checked = false;
          this.$refs.tabs.tabs[this.hoi - 2].active = false;
          this.$refs.tabs.tabs[this.hoi - 2].checked = false;
          this.$refs.tabs.tabs[this.hoi - 3].active = true;
          this.$refs.tabs.tabs[this.hoi - 3].checked = true;

          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }
        if (e.step == "3") {
          this.secondflag = true;
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
          this.$refs.tabs.tabs[this.hoi - 1].checked = false;
          this.$refs.tabs.tabs[this.hoi - 2].active = true;
          this.$refs.tabs.tabs[this.hoi - 2].checked = true;
          this.$refs.tabs.tabs[this.hoi - 3].active = false;
          this.$refs.tabs.tabs[this.hoi - 3].checked = true;
          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }
      }
    },
    getBack() {
      this.$router.push("/Vendor/Job");
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    async validate(tab) {
      let tabToValidate = tab || this.activeTab;

      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then((res) => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    },
  },
};
</script>
